import React from 'react';
import { Icon } from "@blueprintjs/core";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import 'components/form-fields/FormFields.css';

export function FormToggleList({
    items = [],
    value = "",
    disabled,
    onChange = () => {},
    loading = false
}) {

    function onItemChange(item, isDisabled) {

        if(!isDisabled) {
            const selectedItem = item?.key === value ? null : item;
            onChange(selectedItem?.key ?? null, selectedItem);
        }
    }

    return (
        <div className="form-field">
            <div className="form-toggle-list inline-items">
                {items && items.length > 0 && items.map((item) => {

                    const itemColour = item.colour ? item.colour : "black";
                    const isActive = item.key === value;
                    const isDisabled = disabled || (item.count != null && item.count === 0);

                    let toggleStyle = {};

                    if(isActive) {
                        toggleStyle = {
                            borderColor: itemColour,
                            backgroundColor: itemColour + "33",
                        }
                    }

                    return (
                        <button onClick={() => onItemChange(item, isDisabled) } className={classNames('form-toggle-item', {'active': isActive, 'disabled': isDisabled})} style={toggleStyle} key={item.id}>
                            {item.icon && <Icon icon={item.icon} size={11} />}
                            {item.name}
                            {item.count != null && <span className='form-toggle-count' style={{color: itemColour}}>: {item.count}</span>}
                        </button>
                    )
                })}
            </div>
        </div>
    );
}

FormToggleList.propTypes = {
    items: PropTypes.array,
    value: PropTypes.string,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
};